import { Card, CardProps } from "@shopify/polaris";
import React from "react";

interface Props extends CardProps {}

export function PolarisCard(props: Props) {
  return <Card {...props}>{props.children}</Card>;
}
